var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AuthService } from '@app/auth.service';
import { ApiService } from 'app/utility/api.service';
var UserService = /** @class */ (function () {
    function UserService(Auth, Api) {
        this.Auth = Auth;
        this.Api = Api;
    }
    UserService.prototype.isLoggedIn = function () {
        var result = {
            status: false
        };
        var member_info = JSON.parse(sessionStorage.getItem('member_obj'));
        if (member_info != null) {
            if (member_info.member_no != '') {
                result.status = true;
            }
        }
        return result;
    };
    UserService.prototype.logout = function () {
        sessionStorage.setItem('member_obj', null);
        sessionStorage.setItem('current_page_permiss', null);
        this.Auth.setLoggedIn(false);
        var result = {
            status: true
        };
        return result;
    };
    UserService.prototype.ChangePassword = function (User, OldPassword, NewPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        req = {};
                        req['oldPassword'] = OldPassword;
                        req['newPassword'] = NewPassword;
                        req['forcechangepassword'] = false;
                        return [4 /*yield*/, this.Api.put("crmservice", "agentbankChangePassword/" + User, req)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserService.prototype.IsValidatePassword = function (Password) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&\'()*+,-./:;<=>?@[\]^_`{|}])[A-Za-z\d!"#$%&\'()*+,-./:;<=>?@[\]^_`{|}]{8,16}$/.test(Password);
    };
    return UserService;
}());
export { UserService };



// WEBPACK FOOTER //
// ./src/app/user.service.ts.pre-build-optimizer.js